import { defaultKontaktadresseColumns } from "../../../../../config/person";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import { TD, getHeaderActiveColumns } from "../../../../../util/table";
import IngenRegistreringer from "../IngenRegistreringer";
import OpretNyButtonBlock from "../OpretNyButtonBlock";
import { kontanktadresseForm } from "../../../../../config/form/person/mereOmPerson/personKontaktadresseFormConfig";
import { PersonKontaktadresseField } from "../../../../../interfaces/personer";
import { PersonDto } from "../../../../../interfaces/schema";
import ActiveIcon from "../../../../icons/ActiveIcon";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { periodeIsActive } from "../../../../../util/date";
import { orderBy } from "../../../../../util/orderBy";

const Kontaktadresse = ({
  person,
  refetch,
}: {
  person: PersonDto;
  refetch: InvalidateDataFunction<any>;
}) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "BasisWrite");
  const [columns, setColumns] = useActiveColumns(
    "person-kontaktadresse-active-columns",
    defaultKontaktadresseColumns,
  );
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personKontaktadresseSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  const adresser = person.personKontaktadresse;
  if (!adresser || adresser.length === 0) {
    return (
      <IngenRegistreringer
        editConfig={canWrite ? kontanktadresseForm(person.id) : undefined}
        invalidateData={refetch}
      />
    );
  }

  return (
    <>
      <TableBasic
        defaultColumns={defaultKontaktadresseColumns}
        setActiveColumns={setColumns}
        columns={columns}
        headerRow={
          <>
            <th className="indicator"></th>
            {getHeaderActiveColumns(columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        }
      >
        {orderBy(
          adresser,
          sortBy.map((e) => e.field),
          sortBy.map((e) => e.direction),
        ).map((adr, i) => {
          return (
            <TableRow
              editConfig={
                canWrite
                  ? kontanktadresseForm(person.id, adr.id, adr.adresse)
                  : undefined
              }
              invalidateData={refetch}
              key={i}
            >
              <td
                className={`indicator${
                  periodeIsActive(
                    new Date(adr.periode.fraDato),
                    new Date(adr.periode.tilDatoInklusiv),
                  )
                    ? " has-effect"
                    : ""
                }`}
              >
                <ActiveIcon />
              </td>
              <>
                {columns
                  .filter((col) => col.active)
                  .map((col) => (
                    <TD key={col.field} col={col} rowData={adr} />
                  ))}
              </>
            </TableRow>
          );
        })}
      </TableBasic>
      <OpretNyButtonBlock
        editConfig={canWrite ? kontanktadresseForm(person.id) : undefined}
        invalidateData={refetch}
      />
    </>
  );
};

export default Kontaktadresse;

const defaultSortBy: SortBy<PersonKontaktadresseField>[] = [
  {
    direction: "desc",
    field: "periode.tilDatoInklusiv",
  },
  {
    direction: "desc",
    field: "periode.fraDato",
  },
];
